// extracted by mini-css-extract-plugin
export default {"primary":"ProjectLinks_primary__V5TbF"};